import { CloseOutlined, ExclamationCircleFilled } from '@ant-design/icons';

import styles from '@styles/modules/components/ErrorToast.module.scss';

export interface ErrorToastProps {
  title: string;
  description?: string;
  exiting?: boolean;
  onClose: () => void;
}

const ErrorToast = ({ title, description, exiting = false, onClose }: ErrorToastProps) => (
  <div
    className={`${styles.toast} ${exiting ? styles.exiting : ''}`}
    role="alert"
    aria-live="assertive"
  >
    <ExclamationCircleFilled className={styles.icon} aria-hidden />
    <div className={styles.body}>
      <p className={styles.title}>{title}</p>
      {description ? <p className={styles.description}>{description}</p> : null}
    </div>
    <button type="button" className={styles.close} onClick={onClose} aria-label="Dismiss">
      <CloseOutlined />
    </button>
  </div>
);

export default ErrorToast;
